import { render } from "./CustomerRepresentativeDetail.vue?vue&type=template&id=5247c486"
import script from "./CustomerRepresentativeDetail.vue?vue&type=script&lang=js"
export * from "./CustomerRepresentativeDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__